/**
 * Resolves a scope id to its display label using the available-scopes
 * metadata returned by the backend. Falls back to the raw id if the scope
 * is unknown (e.g. scopes list still loading or the scope was retired
 * since the token was issued).
 *
 * @param {string} scopeId The scope id, e.g. "software-statements:create".
 * @param {Array<{id: string, label: string}>} availableScopes The metadata.
 *
 * @returns {string} The label for display.
 */
export function getScopeLabel( scopeId, availableScopes ) {
	const match = ( availableScopes || [] ).find( s => s.id === scopeId );
	return match ? match.label : scopeId;
}
